import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { LanguageProvider } from "./context/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import { isAuthenticated } from './Api/auth';

import DynamicPage from './Pages/DynamicPage';
import WhatsAppFloating from './Components/WhatsAppFloating';

const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
const HomeDashboard = lazy(() => import('./Dashboard/HomeDashboard'));
const PageDashboard = lazy(() => import('./Dashboard/PageDashboard'));
const MenuDashboard = lazy(() => import('./Dashboard/MenuDashboard'));

const ResellerLocations = lazy(() => import('./Pages/ResellerLocations'));
const ServicesMainDashboard = lazy(() => import('./Dashboard/ServicesMainDashboard'));
const HeaderFooterDashboard = lazy(() => import('./Dashboard/HeaderFooterDashboard'));
const ResellerLocationsDashboard = lazy(() => import('./Dashboard/ResellerLocationsDashboard'));
const Services = lazy(() => import('./Pages/Services'));

const ServicePage = lazy(() => import('./Pages/ServicePage'));
const ServicesDashboard = lazy(() => import('./Dashboard/ServicesDashboard'));
const ContactUs = lazy(() => import('./Pages/ContactUs'));
const ContactUsDashboard = lazy(() => import('./Dashboard/ContactUsDashboard'));
const Login = lazy(() => import('./Pages/Login'));
const ServicesMain = lazy(() => import('./Pages/ServicesMain'));
const SettingDashboard = lazy(() => import('./Dashboard/SettingDashboard'));


function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <div className="App">
          <Router>
            <Layout>
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              }></Suspense>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/services-main" element={<ServicesMain />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route path="/reseller-locations" element={<ResellerLocations />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/admin" element={<Login />} />

                <Route path='/dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>}>
                  <Route index element={<HomeDashboard />} />
                  <Route path='home-dashboard' element={<HomeDashboard />} />
                  <Route path='product-main-dashboard' element={<ServicesMainDashboard />} />
                  <Route path='services-dashboard' element={<ServicesDashboard />} />
                  <Route path='reseller-locations-dashboard' element={<ResellerLocationsDashboard />} />
                  <Route path='contactus-dashboard' element={<ContactUsDashboard />} />
                  <Route path='header-footer-dashboard' element={<HeaderFooterDashboard />} />
                  <Route path='menu-dashboard' element={<MenuDashboard />} />
                  <Route path='page-dashboard' element={<PageDashboard />} />
                  <Route path='home-dashboard' element={<HomeDashboard />} />
                  <Route path='setting-dashboard' element={<SettingDashboard />} />
                </Route>

                <Route path='/home' element={<DynamicPage />} />
                <Route path='/:slug' element={<DynamicPage />} />
                <Route path="*" element={<h2>Not Found Page</h2>} />
              </Routes>
            </Layout>
          </Router>
        </div>
      </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;

function Layout({ children }) {
  const location = useLocation();
  const path = location.pathname;
  const hideAll = path === "/admin";
  const hideFooter = path.startsWith("/dashboard");
  return (
    <>
      {!hideAll && <Header />}
      <main className="main-content"><WhatsAppFloating />{children}</main>
      {!hideAll && !hideFooter && <Footer />}
    </>
  );
}

function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/admin" replace />;
}
